/**
 * @package
 * @author Vladimir Stadnik <vladimir.stadnik@cimpleo.com>
 * @class UserName
 */
export class UserName {
  private readonly first!: string;
  private readonly last!: string;
  private readonly patronymic?: string;

  constructor(first: string, last: string, patronymic?: string) {
    this.first = first;
    this.last = last;
    this.patronymic = patronymic;
  }

  public getFirst(): string {
    return this.first;
  }

  public getLast(): string {
    return this.last;
  }

  public getPatronymic(): string {
    return this.patronymic ?? '';
  }
}
